
import React, { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { Navigate } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const PeptidesPage = lazy(() => import('../pages/peptides/page'));
const ShopPage = lazy(() => import('../pages/shop/page'));
const PlaylistsPage = lazy(() => import('../pages/playlists/page'));
const InvestmentPage = lazy(() => import('../pages/investment/page'));
const TopFivePage = lazy(() => import('../pages/top-five/page'));
const ApparelPage = lazy(() => import('../pages/apparel/page'));
const FitnessPage = lazy(() => import('../pages/fitness/page'));
const BookingPage = lazy(() => import('../pages/booking/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/peptides',
    element: <PeptidesPage />,
  },
  {
    path: '/shop',
    element: <ShopPage />,
  },
  {
    path: '/playlists',
    element: <PlaylistsPage />,
  },
  {
    path: '/investment',
    element: <InvestmentPage />,
  },
  {
    path: '/top-five',
    element: <TopFivePage />,
  },
  {
    path: '/apparel',
    element: <ApparelPage />,
  },
  {
    path: '/fitness',
    element: <FitnessPage />,
  },
  {
    path: '/daily-featured',
    element: <Navigate to="/fitness" replace />,
  },
  {
    path: '/booking',
    element: <BookingPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
